import { Box, IconButton } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import type { Scalars } from "@src/__generated__/graphql";
import type { InvoiceTypeEnum } from "@src/components/modules/invoices/Create/store";
import type { ChangeDatesModalStore } from "@src/components/modules/invoices/shared/change-dates-modal/store";
import { Icon } from "@src/components/ui-kit/Icon";
import {
  UncollapseOnHover,
  type UncollapseOnHoverProps,
} from "@src/components/ui-kit/UncollapseOnHover";
import { can } from "@src/utils/components/permissions";
import { WrapComponent } from "@src/utils/components/WrapComponent";
import type { PropsWithChildren } from "react";

interface EditDateWrapperProps
  extends Pick<UncollapseOnHoverProps, "dataComponentName"> {
  row: {
    id: Scalars["ID"]["input"];
    due_date: string | Date;
    issue_date: string | Date;
    paid_at?: string | Date | null;
    date_of_supply?: string | Date | null;
  };
  invoiceType: InvoiceTypeEnum;
  onUpdate: (() => void) | undefined;
  isDisabled?: boolean;
  modalStore: ChangeDatesModalStore | undefined;
}
export const EditDateWrapper = ({
  row,
  children,
  dataComponentName,
  isDisabled,
  invoiceType,
  onUpdate,
  modalStore,
}: PropsWithChildren<EditDateWrapperProps>) => {
  return (
    <WrapComponent
      if={can("outgoingInvoice_accessAccountingAttributes") && !isDisabled}
      with={(children) => (
        <UncollapseOnHover
          dataComponentName={dataComponentName}
          width="4"
          hiddenComponent={
            <IconButton
              aria-label={t`Edit dates modal trigger`}
              icon={<Icon name="edit-02" />}
              onClick={() => {
                modalStore?.modalState.onOpen({
                  id: row.id,
                  due_date: new Date(row.due_date),
                  issue_date: new Date(row.issue_date),
                  date_of_supply: row.date_of_supply
                    ? new Date(row.date_of_supply)
                    : null,
                  paid_at: row.paid_at ? new Date(row.paid_at) : null,
                  invoice_type: invoiceType,
                  onUpdate: () => onUpdate?.(),
                });
              }}
              size="xs"
              variant="ghost"
            />
          }
        >
          <Box>{children}</Box>
        </UncollapseOnHover>
      )}
    >
      {children}
    </WrapComponent>
  );
};
